import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { UserPlus, X } from 'lucide-react';

const ReingresoModal = ({ open, onClose, onSubmit, trabajadorNombre }) => {
  const [nuevaFechaIngreso, setNuevaFechaIngreso] = useState(
    new Date().toISOString().split('T')[0]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(nuevaFechaIngreso);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-emerald-900 flex items-center gap-2">
            <UserPlus className="w-6 h-6" />
            Re-ingreso de Trabajador
          </DialogTitle>
          <DialogDescription>
            Registrar el re-ingreso de <strong>{trabajadorNombre}</strong>
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          {/* Información */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-900">
              <strong>ℹ️ Información:</strong> Se reutilizarán todos los datos del trabajador. 
              Solo necesitas ingresar la nueva fecha de inicio.
            </p>
          </div>

          {/* Nueva Fecha de Ingreso */}
          <div>
            <Label className="text-emerald-900 font-semibold">
              Nueva Fecha de Ingreso *
            </Label>
            <Input
              type="date"
              value={nuevaFechaIngreso}
              onChange={(e) => setNuevaFechaIngreso(e.target.value)}
              className="mt-1"
              required
            />
            <p className="text-xs text-gray-500 mt-1">
              Esta será la fecha de inicio del nuevo periodo laboral
            </p>
          </div>

          {/* Advertencia */}
          <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-3">
            <p className="text-sm text-emerald-800">
              <strong>✓ Acción:</strong> El trabajador será marcado como <strong>Activo</strong> nuevamente 
              y se iniciará un nuevo periodo laboral.
            </p>
          </div>

          {/* Botones */}
          <div className="flex justify-end gap-2 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="border-gray-300"
            >
              <X className="w-4 h-4 mr-2" />
              Cancelar
            </Button>
            <Button
              type="submit"
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <UserPlus className="w-4 h-4 mr-2" />
              Confirmar Re-ingreso
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ReingresoModal;
